// extracted by mini-css-extract-plugin
module.exports = {"inputMask":"InputMaskField_inputMask__3PKMa","empty":"InputMaskField_empty__MAm4w"};